import { NavbarHome } from "./NavbarHome";
import { HeaderHomeSplash } from "./HeaderHomeSplash";
import * as css from "./HeaderHome.module.scss";

export function HeaderHome({scrollHandlers}) {
    return (
      <header>
        <NavbarHome scrollHandlers={scrollHandlers} />
        <HeaderHomeSplash />
      </header>
    );
  }